import { PropertyAnswer } from '../../gql/graphql'

export interface FilterPropertyAnswer extends PropertyAnswer {
  checked: boolean
}

export const EMPTY_FILTER_VALUE = '__empty__'
